import {CellStyle} from './CellStyle';

export class XlsPivotTotalSubColumnConfiguration {
key: string;
style: CellStyle;
}

